var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.5198 19.2c0-2.1178-1.7222-3.84-3.84-3.84h-1.92v-5.76c0-5.29344-4.3066-9.6-9.6-9.6s-9.6 4.30656-9.6 9.6v5.76h-1.92c-2.11776 0-3.84 1.7222-3.84 3.84v15.36c0 2.1178 1.72224 3.84 3.84 3.84h23.04c2.1178 0 3.84-1.7222 3.84-3.84zm-21.12-9.6c0-3.17568 2.5843-5.76 5.76-5.76s5.76 2.58432 5.76 5.76v5.76h-11.52z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0fe5b624eb62783ac21902b07e4993c7.svg";
export { ForwardRef as ReactComponent };